import axios from "axios";
import URLS from "../modules/util/urls.js";

const state = {

}

const mutations = {

}

const actions = {
  listarContasImobiliaria(context, payload) {
    return axios.post(URLS.CONTAS_BANCARIAS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarContasImobiliaria", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  }
}

export default {
  state,
  mutations,
  actions
}